/* eslint-disable no-undef */
import './Hompage.scss';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Button from '@mui/material/Button';
import React from 'react';
import { useEffect } from 'react';
import {useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {buttonStylesBlue, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import Footer from '../../Components/shared/Footer/Footer';
import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import { DrawIconCheckPricing, DrawIconPremiumPricing, DrawIconsPrincing2, DrawIconsPrincing9, DrawIconspRricing, DrawIconStarPricing, DrawIconUnCheckPricing, DrawImageHomeExpert26 } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';

function Pricing() {

    // ! multiLanguages
    const { t, i18n } = useTranslation();

    console.log(t, i18n);
    const navigate=useNavigate();
    const {device}=useWindowSize();
    usePersistedLanguage();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes
    return (
        <div
            className='App-intro'
            style={{gap:'0px'}}
        >
            <NavbarHome />
            <div style={{display:'flex',flexDirection:'column',gap:'135px',alignItems:'center',width:'100%'}}>
                <div style={{display:'flex',flexDirection:'column',gap:'115px',alignItems:'center',alignSelf:'stretch'}}>

                    <div style={{background:'linear-gradient(171deg, rgba(231,234,249,1) 0%, rgba(255,255,255,1) 56%)',display:'flex',flexDirection:'column',gap:'115px',alignItems:'center',alignSelf:'stretch'}}>
                        <div
                            className='frame98HomePage'
                            style={{marginTop:'50px'}}
                        >
                            <div className='frame99HomePage'>
                                <div className='frame100HomePage'>
                                    <h3
                                        className='frame101HomePage'
                                        style={{justifyContent:device=='desktop'?'flex-start':'center'}}
                                    >{i18n.t('Solutions sur mesure')} </h3>
                                    {device!='desktop' &&
                                    <div className='frame104HomePage'>
                                        <DrawIconsPrincing9
                                            width={'80%'}
                                            height={'100%'}
                                        />
                                    </div>
                                    }
                                    <h6
                                        className='frame102HomePage'
                                        style={{color:'#475063',textAlign:device=='desktop'?'start':'center'}}
                                    >{i18n.t('Avec HTH Pay what you use!')}<br/>
                                        {i18n.t('Nos solutions sont sur mesure, choisissez celle la plus adaptée à votre besoin.')}</h6>
                                </div>
                                <div className='frame103HomePage'>
                                    <Button
                                        variant="contained"
                                        sx={{height: 56}}
                                        //style={{
                                        //    backgroundColor: '#214DCE',
                                        //    borderRadius: '8px',
                                        //}}
                                        onClick={()=>{navigate('/register');}}
                                        style={{...buttonStylesBlue(),...{width:device=='desktop'?'auto':'100%'}}}
                                        startIcon={<CalendarTodayIcon />}
                                    > {i18n.t('Nous Rejoindre')}
                                    </Button>
                                </div>
                            </div>
                            {device=='desktop' &&
                            <div className='frame104HomePage'>
                                <DrawIconsPrincing9 />
                            </div>
                            }
                        </div>

                        <div className='pricingF0 pricingF1'>
                            <div className='pricingF2'>
                                <h3 className='pricingF17'> {i18n.t('Nos offres')} </h3>
                                <h5
                                    className='pricingF18'
                                    style={{textAlign: 'center'}}
                                > {i18n.t('Client')} <span style={{color:'#475063'}}>{i18n.t('et')}</span><span style={{color:'#5CC889'}}> {i18n.t('ESN')} </span></h5>
                            </div>
                            <div className='pricingF2 pricingF3'>
                                <div
                                    className='pricingF4'
                                    style={{width:device=='desktop'?'20%':'100%'}}
                                >
                                    <h5 className='pricingF18'>{i18n.t('Sourcing')}</h5>
                                    <DrawIconspRricing  device={device}/>
                                    <div className='pricingF2'>
                                        <h6
                                            className='pricingF14'
                                            style={{margin:'0px'}}
                                        >{i18n.t('Le plan comprend')} </h6>
                                        <ul className='pricingF19'>
                                            <li>{i18n.t('Poster une offre')}</li>
                                            <li>{i18n.t('Accès à la CVthèque')}</li>
                                        </ul>
                                    </div>

                                </div>

                                <div
                                    className='pricingF4'
                                    style={{width:device=='desktop'?'21%':'100%'}}
                                >
                                    <h5 className='pricingF18'>{i18n.t('Source to pay')}</h5>
                                    <DrawIconspRricing  device={device}/>
                                    <div className='pricingF2'>
                                        <h6
                                            className='pricingF14'
                                            style={{margin:'0px'}}
                                        >{i18n.t('Le plan comprend')} </h6>
                                        <ul className='pricingF19'>
                                            <li>{i18n.t('Poster une offre')}</li>
                                            <li>{i18n.t('Accès à la CVthèque')}</li>
                                            <li>{i18n.t('Responsaibilité juridique')}</li>
                                            <li>{i18n.t('Gestion des CRA')}</li>
                                            <li>{i18n.t('Gestion de la facturation')}</li>
                                            <li>{i18n.t('Paiement des freelances')}</li>
                                            <li>{i18n.t('Outil de suivi')}</li>

                                        </ul>
                                    </div>

                                </div>

                                <div
                                    className='pricingF4'
                                    style={{width:device=='desktop'?'21%':'100%',background:'#E3F5EA',borderColor:'#5CC889'}}
                                >
                                    <h5
                                        className='pricingF18'
                                        style={{color:'#5CC889'}}
                                    >{i18n.t('Premium')} <DrawIconStarPricing /></h5>
                                    <DrawIconPremiumPricing  device={device}/>
                                    <div className='pricingF2'>
                                        <h6
                                            className='pricingF14'
                                            style={{margin:'0px'}}
                                        >{i18n.t('Le plan comprend')} </h6>
                                        <ul className='pricingF19'>
                                            <li>{i18n.t('HTH Source pour vous')}</li>
                                            <li>{i18n.t('Poster une offre')}</li>
                                            <li>{i18n.t('Accès à la CVthèque')}</li>
                                            <li>{i18n.t('Responsabilité juridique')}</li>
                                            <li>{i18n.t('Gestion des CRA')}</li>
                                            <li>{i18n.t('Gestion de la facturation')}</li>
                                            <li>{i18n.t('Paiement des freelances')}</li>
                                            <li>{i18n.t('Outil de suivi')}</li>

                                        </ul>
                                    </div>

                                </div>

                                <div
                                    className='pricingF4'
                                    style={{width:device=='desktop'?'19%':'100%'}}
                                >
                                    <h5 className='pricingF18'>{i18n.t('VMS Light')}</h5>
                                    <DrawIconspRricing device={device}/>
                                    <div className='pricingF2'>
                                        <h6
                                            className='pricingF14'
                                            style={{margin:'0px'}}
                                        >{i18n.t('Le plan comprend')} </h6>
                                        <ul className='pricingF19'>
                                            <li>{i18n.t('Gestion des CRA')}</li>
                                            <li>{i18n.t('Gestion de la facturation')}</li>
                                            <li>{i18n.t('Outil de suivi')}</li>
                                        </ul>
                                    </div>

                                </div>

                                <div
                                    className='pricingF4'
                                    style={{width:device=='desktop'?'19%':'100%'}}
                                >
                                    <h5 className='pricingF18'>{i18n.t('VMS')}</h5>
                                    <DrawIconspRricing device={device}/>
                                    <div className='pricingF2'>
                                        <h6
                                            className='pricingF14'
                                            style={{margin:'0px'}}
                                        >{i18n.t('Le plan comprend')} </h6>
                                        <ul className='pricingF19'>
                                            <li>{i18n.t('Responsabilité juridique')}</li>
                                            <li>{i18n.t('Gestion des CRA')}</li>
                                            <li>{i18n.t('Gestion de la facturation')}</li>
                                            <li>{i18n.t('Paiement des freelances')}</li>
                                            <li>{i18n.t('Outil de suivi')}</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <Button
                                onClick={()=>{navigate('/register');}}
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                            >
                                {i18n.t('Nous Rejoindre')}
                            </Button>
                        </div>

                    </div>

                    <div className='pricingF0 pricingF5'>
                        {device=='desktop' &&
                        <DrawIconsPrincing2 width={'480'}/>
                        }
                        <div className='pricingF6 pricingF7'>
                            <h3 className='frame101HomePage'>{i18n.t('Vous êtes freelance')}</h3>
                            {device!='desktop' &&
                            <DrawIconsPrincing2 width={'100%'}/>
                            }
                            <div className='pricingF6 pricingF8'>
                                <h5 className='pricingF25'>{i18n.t('L\'utilisation de la plateforme est 100% gratuite')}</h5>
                                <ol className='pricingF26'>
                                    <li><h6 className='pricingF26'>{i18n.t('Inscrivez-vous')}</h6></li>
                                    <li><h6 className='pricingF26'>{i18n.t('Choisissez votre tarif journalier')}</h6></li>
                                    <li><h6 className='pricingF26'>{i18n.t('Postulez aux annonces')}</h6></li>
                                    <li><h6 className='pricingF26'>{i18n.t('HTH fait matcher votre profil au besoin client')}</h6></li>
                                    <li><h6 className='pricingF26'>{i18n.t('Recevez des propositions de missions')}</h6></li>
                                    <li><h6 className='pricingF26'>{i18n.t('Suivez vos missions, CRA et factures')}</h6></li>
                                </ol>
                            </div>
                            <Button style={{...buttonStylesGreen(false),...{width:device=='desktop'?'fit-content':'100%'}}}>
                                {i18n.t('Inscrivez vous')}
                            </Button>

                        </div>
                    </div>

                    <div className='pricingF0 pricingF24'>
                        <div
                            className='pricingF3 '
                            style={{gap:'48px'}}
                        >
                            <h3
                                className='frame101HomePage'
                                style={{whiteSpace:device=='desktop'?'nowrap':'normal'}}
                            >{i18n.t('Tarification Transparente')}</h3>
                            <h5
                                className='pricingF25'
                                style={{color:'#475063',fontSize:'21px'}}
                            >
                                {i18n.t('Nous offrons le meilleur service et le meilleur prix à nos clients et à nos experts, avec une totale transparence')}
                            </h5>
                        </div>
                        <div style={{width:'100%',overflowX:'auto'}}>
                            <table className='pricingF9' >
                                <tr style={{height:'48px'}}>
                                    <th style={{width:'18%'}}> </th>
                                    <th
                                        className='pricingF14 pricingF15'
                                        style={{width:'16%',textAlign:'center',
                                            borderTopLeftRadius: '20px',
                                            borderTopRightRadius: '20px',

                                        }}
                                    ><h6 style={{margin:'0px',color:'white'}}>{i18n.t('Premium HTH')}</h6></th>
                                    <th
                                        className=' pricingF14'
                                        style={{width:'16%',textAlign:'center'}}
                                    ><h6 style={{margin:'0px'}}>{i18n.t('Source to pay')}</h6></th>
                                    <th
                                        className=' pricingF14'
                                        style={{width:'16%',textAlign:'center'}}
                                    ><h6 style={{margin:'0px'}}>{i18n.t('Sourcing')}</h6></th>
                                    <th
                                        className=' pricingF14'
                                        style={{width:'16%',textAlign:'center'}}
                                    ><h6 style={{margin:'0px'}}>{i18n.t('VMS')}</h6></th>
                                    <th
                                        className='pricingF14'
                                        style={{width:'16%',textAlign:'center'}}
                                    ><h6 style={{margin:'0px'}}>{i18n.t('Portage commercial')}</h6></th>
                                </tr>
                                <tr className='pricingF12'>
                                    <td
                                        className='pricingF13 pricingF14 pricingF20 pricingF23'
                                        style={{borderTopLeftRadius:'10px'}}
                                    ><h6>{i18n.t('HTH source pour vous')}</h6></td>
                                    <td className='pricingF13 pricingF16 pricingF20'><DrawIconCheckPricing color={'white'}/></td>
                                    <td className='pricingF13 pricingF20'><DrawIconCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconCheckPricing /></td>
                                    <td
                                        className='pricingF13 pricingF20 pricingF22'
                                        style={{borderTopRightRadius:'10px'}}
                                    ><DrawIconCheckPricing /></td>
                                </tr>
                                <tr className='pricingF10' >
                                    <td className='pricingF13 pricingF14 pricingF20 pricingF23'><h6>{i18n.t('Poster une offre')}</h6></td>
                                    <td className='pricingF13 pricingF15 pricingF20'><DrawIconUnCheckPricing color={'white'}/></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20 pricingF22'><DrawIconUnCheckPricing /></td>
                                </tr>
                                <tr className='pricingF10 pricingF12'>
                                    <td className='pricingF13 pricingF14 pricingF20 pricingF23'><h6>{i18n.t('Accès à CVthèque')} </h6></td>
                                    <td className='pricingF13 pricingF16 pricingF20'><DrawIconUnCheckPricing color={'white'} /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20 pricingF22'><DrawIconUnCheckPricing /></td>
                                </tr>
                                <tr className='pricingF10' >
                                    <td className='pricingF13 pricingF14 pricingF20 pricingF23'><h6>{i18n.t('Responsabilité juridique')}</h6> </td>
                                    <td className='pricingF13 pricingF15 pricingF20'><DrawIconUnCheckPricing color={'white'}/></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20 pricingF22'><DrawIconUnCheckPricing /></td>
                                </tr>
                                <tr className='pricingF10 pricingF12'>
                                    <td className='pricingF13 pricingF14 pricingF20 pricingF23'><h6>{i18n.t('Gestion des CRA')}</h6></td>
                                    <td className='pricingF13 pricingF16 pricingF20'><DrawIconCheckPricing color={'white'}/></td>
                                    <td className='pricingF13 pricingF20'><DrawIconCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconCheckPricing /></td>
                                    <td className='pricingF13 pricingF20 pricingF22'><DrawIconCheckPricing /></td>
                                </tr>
                                <tr className='pricingF10' >
                                    <td className='pricingF13 pricingF14 pricingF20 pricingF23'><h6>{i18n.t('Gestion de la facturation')}</h6> </td>
                                    <td className='pricingF13 pricingF15 pricingF20'><DrawIconCheckPricing color={'white'}/></td>
                                    <td className='pricingF13 pricingF20'><DrawIconCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20 pricingF22'><DrawIconUnCheckPricing /></td>
                                </tr>
                                <tr className='pricingF10 pricingF12'>
                                    <td className='pricingF13 pricingF14 pricingF20 pricingF23'><h6>{i18n.t('Paiement des freelances')} </h6></td>
                                    <td className='pricingF13 pricingF16 pricingF20'><DrawIconUnCheckPricing color={'white'} /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20 pricingF22'><DrawIconCheckPricing /></td>
                                </tr>
                                <tr className='pricingF10' >
                                    <td
                                        className='pricingF13 pricingF14 pricingF20 pricingF23'
                                        style={{borderBottomLeftRadius:'10px'}}
                                    ><h6>{i18n.t('Outil suivi')}</h6></td>
                                    <td className='pricingF13 pricingF15 pricingF20'><DrawIconUnCheckPricing color={'white'}/></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td className='pricingF13 pricingF20'><DrawIconUnCheckPricing /></td>
                                    <td
                                        className='pricingF13 pricingF20 pricingF22'
                                        style={{borderBottomRightRadius:'10px'}}
                                    ><DrawIconCheckPricing /></td>
                                </tr>
                                <tr
                                    className='pricingF10'
                                    style={{
                                        border:'none',
                                        height:'20px',
                                    }}
                                >
                                    <td className='pricingF13'></td>
                                    <td
                                        className='pricingF13 pricingF15'
                                        style={{
                                            borderBottomLeftRadius: '20px',
                                            borderBottomRightRadius: '20px',
                                        }}
                                    ></td>
                                    <td className='pricingF13'></td>
                                    <td className='pricingF13'></td>
                                    <td className='pricingF13'></td>
                                    <td className='pricingF13'></td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div className='homeExpertf44'>
                        <div className='homeExpertf45'>
                            <h3 className='frame101HomePage'>
                                {i18n.t('Prêt à nous rejoindre et à adopter notre solution')}
                            </h3>
                            <Button
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                                onClick={()=>{
                                    navigate('/register');
                                }}
                            >
                                {i18n.t('S\'inscrire')}
                            </Button>
                        </div>
                        <DrawImageHomeExpert26 />
                    </div>

                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Pricing;